import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";

import * as componentTypes from "../../../../../constants/componentTypes";
import * as serverActions from "../../../../../actions/serverActions";
import * as navigationActions from "../../../../../actions/navigationActions";

class EditServerModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            serverName: this.props.params.name !== null ? this.props.params.name : "",
            serverNote: this.props.params.note !== null ? this.props.params.note : "",
            serverEnabled: this.props.params.enabled !== null ? this.props.params.enabled : ""
        };
    }

    handleEditButtonClick = () => {
        this.props.dispatchEditServerAction(
            this.props.params.id,
            this.state.serverName,
            this.state.serverNote,
            this.state.serverEnabled
        );
        this.props.dispatchCloseServerModalAction();
    };

    handleServerNoteChange = (event) => {
        this.setState({
            serverNote: event.target.value
        });
    };

    handleServerNameChange = (event) => {
        this.setState({
            serverName: event.target.value
        });
    };

    handleCloseModalClick = () => {
        this.props.dispatchCloseServerModalAction();
    };

    handleInputFocus = (event) => {
        event.target.select();
    };

    handleServerEnableChange = () => {
        this.setState({
            serverEnabled: !this.state.serverEnabled
        });
    };

    render() {
        return (
            <div id="modal" className="default-modal settings-modal ig-small-modal server-modal">
                <div className="modal-content">
                    <h4 className="col-xs-12 text-left">
                        <Translate value="clientServerSettings.editServer" />
                    </h4>
                    <div className="row select-machine-title">
                        <div className="col-xs-4 text-right">
                            <Translate value="clientServerSettings.serverName" />:
                        </div>
                        <div className="col-xs-8">
                            <input
                                className="input-dark"
                                type="text"
                                value={this.state.serverName}
                                onChange={this.handleServerNameChange}
                                onFocus={this.handleInputFocus}
                            />
                        </div>
                    </div>
                    <div className="row select-machine-title">
                        <div className="col-xs-4 text-right">
                            <Translate value="general.note" />:
                        </div>
                        <div className="col-xs-8">
                            <input
                                className="input-dark"
                                type="text"
                                value={this.state.serverNote}
                                onChange={this.handleServerNoteChange}
                                onFocus={this.handleInputFocus}
                            />
                        </div>
                    </div>
                    <div className="row select-machine-title">
                        <div className="col-xs-4 text-right">
                            <Translate value="general.enabled" />:
                        </div>
                        <div className="col-xs-8 checkbox-box">
                            <div className="settings-checkbox-style" onClick={this.handleServerEnableChange}>
                                <input
                                    type="checkbox"
                                    name="show"
                                    className="checkbox"
                                    checked={this.state.serverEnabled}
                                    onChange={this.handleServerEnableChange}
                                />
                                <span className="checkmark" />
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <div className="col-xs-12 text-right">
                            <button className="btn btn-danger btn-md btn-arrow" onClick={this.handleEditButtonClick}>
                                <Translate value="general.edit" />
                            </button>
                            <button className="btn btn-danger btn-md btn-arrow" onClick={this.handleCloseModalClick}>
                                <Translate value="general.cancel" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStoreToProps = () => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseServerModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.INTERGAMMA_EDIT_SERVER_MODAL));
        },
        dispatchEditServerAction: (id, name, note, enabled) => {
            dispatch(serverActions.editServer(id, name, note, enabled));
        }
    };
};

export default EditServerModal = connect(mapStoreToProps, mapDispatchToProps)(EditServerModal);
